import React, { useEffect, useState } from 'react'

import Checkbox from 'live/components/ui/TriStateCheckbox'

import { IAlarmOperation } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarms/BowtieAlarms'
import { IAlarmGroup } from 'plugin-codaf-risk-ext-bowtie/types/alarms'

import { OperationCardContainer } from './styles'

interface IProps {
    operation: IAlarmOperation
    operationSelectedBowties: number[]
    setOperationSelectedBowties: (operations: number[]) => void
    setAlarmGroup: (group: IAlarmGroup) => void
    alarmGroup: IAlarmGroup
}

export const OperationCard: React.FC<IProps> = ({
    operation,
    setOperationSelectedBowties,
    operationSelectedBowties,
    setAlarmGroup,
    alarmGroup
}) => {
    const [bowtiesVisible, setBowtiesVisible] = useState<boolean>(false)

    const handleCheckedBowtieState = (id: number): boolean => {
        return operationSelectedBowties.includes(id)
    }

    const handleBowtieCheckedState = (id: number): void => {
        if (operationSelectedBowties.includes(id)) {
            operationSelectedBowties = operationSelectedBowties.filter(e => e !== id)
        } else {
            operationSelectedBowties.push(id)
        }
        setOperationSelectedBowties([...operationSelectedBowties])
    }

    const handleCheckedOperationState = (): { checked: boolean; indeterminate: boolean } => {
        const bowties = operation.bowties
        const arrayBowtiesSelected = operationSelectedBowties.length
        const checked = arrayBowtiesSelected === bowties.length
        const indeterminate = arrayBowtiesSelected > 0 && !checked

        return { checked, indeterminate }
    }

    const handleOperationCheckedState = (): void => {
        const bowties = operation.bowties
        const arrayBowtiesSelected = operationSelectedBowties.length
        const checked = arrayBowtiesSelected === bowties.length

        setOperationSelectedBowties(checked ? [] : bowties.map(e => e.id))
    }

    return (
        <OperationCardContainer>
            <div className="header-wrapper">
                <i
                    className={`fas fa-caret-${bowtiesVisible ? 'up' : 'down'}`}
                    onClick={() => {
                        setBowtiesVisible(old => !old)
                    }}
                ></i>
                {operation.description}
                <Checkbox {...handleCheckedOperationState()} onChange={() => handleOperationCheckedState()} />
            </div>
            {bowtiesVisible && (
                <div className={`bowtie-list`}>
                    {operation.bowties.map((bowtie, index) => (
                        <div className={'bowtie-name'} key={index}>
                            {bowtie.bowtieCode}
                            <Checkbox
                                onChange={() => {
                                    handleBowtieCheckedState(bowtie.id)
                                }}
                                checked={handleCheckedBowtieState(bowtie.id)}
                            />
                        </div>
                    ))}
                </div>
            )}
        </OperationCardContainer>
    )
}
